export default __webpack_public_path__ + "static/media/content.02a40e6b.svg";